/**
 * DeliveryList — the per-recipient outcome of an invoice send (IDI-485):
 * email, sent / redirected / failed, and the detail. Read from the stored
 * `deliveries` (and `ccDelivery` for the one CC copy). IDI-580: deliveries
 * are a history across sends; only the latest send's rows are listed
 * (invoiceDeliveries), and ccDelivery is the latest send's CC copy.
 */
import React from 'react';
import { invoiceDeliveries } from './invoiceLifecycle';

const LABEL = { sent: 'Sent', redirected: 'Redirected', failed: 'Failed' };

export default function DeliveryList({ invoice, title = 'Email delivery' }) {
  const rows = invoiceDeliveries(invoice);
  if (rows.length === 0) return null;
  const cc = invoice?.ccDelivery;
  const ccList = Array.isArray(cc?.cc) ? cc.cc : [];
  return (
    <div data-testid="invoice-delivery-list">
      <h3 className="text-sm font-semibold text-content-primary mb-2">{title}</h3>
      <ul className="space-y-1">
        {rows.map((r) => (
          <li key={r.email} className="text-sm flex flex-wrap gap-x-2" data-testid="invoice-delivery-row">
            <span className="text-content-primary">{r.email}</span>
            <span
              className="font-medium"
              style={{ color: r.status === 'failed' ? 'var(--color-error)' : 'var(--color-text-secondary)' }}
            >
              {LABEL[r.status] || r.status}
            </span>
            {r.detail && <span className="text-content-secondary">{r.detail}</span>}
          </li>
        ))}
        {ccList.length > 0 && (
          <li className="text-sm flex flex-wrap gap-x-2" data-testid="invoice-delivery-cc">
            <span className="text-content-primary">CC copy: {ccList.join(', ')}</span>
            <span className="font-medium" style={{ color: cc.status === 'failed' ? 'var(--color-error)' : 'var(--color-text-secondary)' }}>
              {LABEL[cc.status] || cc.status}
            </span>
            {cc.detail && <span className="text-content-secondary">{cc.detail}</span>}
          </li>
        )}
      </ul>
    </div>
  );
}
